module.exports = __webpack_public_path__ + "img/coupon_tutorial01.55b00973.jpg";